import { render } from "./TeamStyleOne.vue?vue&type=template&id=0715a020"
import script from "./TeamStyleOne.vue?vue&type=script&lang=js"
export * from "./TeamStyleOne.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__